document.querySelectorAll('.accordion__button').forEach(button => {
    button.addEventListener('click', () => {
        const accordionContent = button.nextElementSibling;

        console.log(accordionContent);

        button.classList.toggle('accordion__button--active');

        if (button.classList.contains('accordion__button--active')) {
            accordionContent.classList.add('accordion__content--active');
        } else {
            accordionContent.classList.remove('accordion__content--active');
        }
    })
});

document.querySelectorAll('.title-faq').forEach(subButton => {
    subButton.addEventListener('click', () => {
        const subFAQ = subButton.nextElementSibling;

        console.log(subFAQ);

        subButton.classList.toggle('title-faq--active');

        if (subButton.classList.contains('title-faq--active')) {
            subFAQ.classList.add('faq-content--active');
        } else {
            subFAQ.classList.remove('faq-content--active');
        }
    })
});